import { useUserInfo } from "@/api/user";
import { trialDaysRemaining } from "@/utils/trial";

export type TrialStatus = {
  isTrialing: boolean;
  daysRemaining: number | undefined;
  includedCredits: number;
  creditsUsed: number;
  creditsRemaining: number;
};

/**
 * Trial state off the same /me numbers the rail credit ring reads, so the
 * two never disagree.
 */
export function useTrialStatus(): TrialStatus {
  const { data: userInfo } = useUserInfo();
  const subscription = userInfo?.subscription;
  const includedCredits = subscription?.included_credits_per_seat ?? 0;
  const creditsUsed = userInfo?.usage?.current_period_user_credit_count ?? 0;

  return {
    isTrialing: subscription?.status === "trialing",
    daysRemaining: trialDaysRemaining(subscription?.current_period_end),
    includedCredits,
    creditsUsed,
    creditsRemaining: Math.max(0, includedCredits - creditsUsed),
  };
}
